import React, { useState } from 'react';
import './DomainTransfer.css';

const DomainTransfer = () => {
  const [domainName, setDomainName] = useState('');
  const [authCode, setAuthCode] = useState('');

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  const handleTransfer = () => {
    if (!domainName.trim()) {
      alert('لطفاً نام دامنه را وارد کنید');
      return;
    }
    if (!authCode.trim()) {
      alert('لطفاً کد انتقال (Auth Code) را وارد کنید');
      return;
    }
    window.open('https://hub.afracell.com/cart.php?a=add&domain=transfer&query=' + encodeURIComponent(domainName.trim()), '_blank');
  };

  const features = [
    {
      icon: '🔄',
      title: 'انتقال رایگان دامنه',
      desc: 'انتقال دامنه از هر ثبت‌کننده‌ای به افرسل کاملاً رایگان است. هیچ هزینه اضافی برای انتقال دریافت نمی‌شود.',
    },
    {
      icon: '🎁',
      title: 'تمدید یکساله رایگان',
      desc: 'به ازای هر دامنه‌ای که به افرسل انتقال می‌دهید، یک سال تمدید رایگان دریافت می‌کنید.',
    },
    {
      icon: '🛡️',
      title: 'مدیریت DNS پیشرفته',
      desc: 'پس از انتقال، از پنل مدیریت DNS پیشرفته با امکانات کامل بهره‌مند می‌شوید.',
    },
    {
      icon: '⏱️',
      title: 'انتقال سریع و بدون دردسر',
      desc: 'فرآیند انتقال دامنه به افرسل ساده و سریع است و تیم پشتیبانی در تمام مراحل راهنمایی شماست.',
    },
  ];

  const steps = [
    {
      number: '۰۱',
      title: 'دریافت کد انتقال (Auth Code)',
      desc: 'از ثبت‌کننده فعلی خود کد انتقال (EPP Code یا Auth Code) را دریافت کنید.',
    },
    {
      number: '۰۲',
      title: 'ثبت درخواست انتقال در افرسل',
      desc: 'نام دامنه و کد انتقال را در فرم انتقال افرسل وارد کنید و درخواست خود را ثبت نمایید.',
    },
    {
      number: '۰۳',
      title: 'تأیید درخواست انتقال',
      desc: 'ایمیلی از طرف ثبت‌کننده فعلی دریافت می‌کنید که باید آن را تأیید کنید. در برخی موارد، نیاز به تأیید از طریق پنل ثبت‌کننده فعلی نیز دارید.',
    },
    {
      number: '۰۴',
      title: 'تکمیل انتقال و تمدید رایگان',
      desc: 'پس از تأیید، فرآیند انتقال تکمیل شده و یک سال تمدید رایگان به دامنه شما اضافه می‌شود.',
    },
  ];

  const faqs = [
    {
      q: 'انتقال دامنه به افرسل چقدر زمان می‌برد و آیا وب‌سایت من قطع می‌شود؟',
      a: 'فرآیند انتقال دامنه معمولاً بین ۱ تا ۵ روز کاری طول می‌کشد. در این مدت، وب‌سایت شما کاملاً فعال است و هیچ گونه قطعی در دسترسی به سایت شما ایجاد نمی‌شود. تنظیمات DNS و سرورهای نام شما بدون تغییر باقی می‌مانند و کاربران شما هیچ گونه اختلالی را تجربه نمی‌کنند. پس از تکمیل انتقال، یک سال تمدید رایگان به دامنه شما اضافه می‌شود.',
    },
    {
      q: 'آیا انتقال دامنه هزینه دارد و چه مدارکی نیاز است؟',
      a: 'انتقال دامنه به افرسل کاملاً رایگان است و هیچ هزینه اضافی دریافت نمی‌شود. برای انتقال، شما فقط به کد انتقال (Auth Code یا EPP Code) نیاز دارید که باید از ثبت‌کننده فعلی خود دریافت کنید. همچنین، ایمیلی که ثبت‌کننده فعلی برای تأیید انتقال ارسال می‌کند را باید تأیید کنید. در بیشتر موارد، نیازی به مدارک اضافی نیست مگر اینکه ثبت‌کننده فعلی درخواست مدارک خاصی داشته باشد.',
    },
    {
      q: 'چه دامنه‌هایی را می‌توانم به افرسل انتقال دهم؟',
      a: 'شما می‌توانید اکثر دامنه‌های ملی و بین‌المللی را به افرسل انتقال دهید. دامنه‌های با پسوند .ir، .com، .net، .org، .info، .io، .co و بسیاری از پسوندهای دیگر قابل انتقال هستند. برای دامنه‌های ملی ایران (.ir و زیرمجموعه‌های آن)، فرآیند انتقال کمی متفاوت است و نیاز به تأیید هویت از طریق مرکز ثبت دامنه ایران دارد. تیم پشتیبانی ما در تمام مراحل راهنمایی شما خواهد بود.',
    },
  ];

  return (
    <>
      <div className="seo-header">
        <h1>انتقال دامنه به افرسل | انتقال رایگان با تمدید یکساله | افرسل</h1>
        <p>انتقال دامنه از هر ثبت‌کننده‌ای به افرسل به صورت کاملاً رایگان. به ازای هر دامنه، یک سال تمدید رایگان دریافت کنید. مدیریت DNS پیشرفته، پشتیبانی ۲۴ ساعته و فرآیند انتقال ساده.</p>
        <meta name="description" content="انتقال دامنه به افرسل کاملاً رایگان با تمدید یکساله. انتقال دامنه از هر ثبت‌کننده‌ای، مدیریت DNS پیشرفته و پشتیبانی ۲۴/۷." />
      </div>

      <section className="transfer-hero">
        <div className="transfer-hero-bg"></div>
        <div className="wrap">
          <div className="transfer-hero-content">
            <div className="transfer-badge">
              <span className="pulse-dot"></span>
              🔄 انتقال دامنه
            </div>
            <h1 className="transfer-hero-title">
              انتقال <em>رایگان</em> دامنه
            </h1>
            <p className="transfer-hero-desc">
              دامنه خود را به افرسل انتقال دهید و از مزایای ویژه بهره‌مند شوید. 
              انتقال کاملاً رایگان، تمدید یکساله رایگان، مدیریت DNS پیشرفته و پشتیبانی ۲۴ ساعته. 
              فرآیند انتقال ساده و سریع است و وب‌سایت شما هیچ گونه قطعی نخواهد داشت.
            </p>
            <div className="transfer-hero-stats">
              <div className="stat-item">
                <span className="stat-number">رایگان</span>
                <span className="stat-label">هزینه انتقال</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">۱ سال</span>
                <span className="stat-label">تمدید رایگان</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">۱-۵ روز</span>
                <span className="stat-label">زمان انتقال</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="transfer-form-section">
        <div className="wrap">
          <div className="transfer-form-box">
            <h3 className="transfer-form-title">دامنه خود را انتقال دهید</h3>
            <p className="transfer-form-desc">نام دامنه و کد انتقال را وارد کنید تا فرآیند انتقال آغاز شود.</p>
            <div className="transfer-form">
              <input
                type="text"
                className="transfer-input"
                placeholder="نام دامنه (مثال: mydomain.com)"
                value={domainName}
                onChange={(e) => setDomainName(e.target.value)}
                dir="ltr"
              />
              <input
                type="text"
                className="transfer-input"
                placeholder="کد انتقال (Auth Code / EPP Code)"
                value={authCode}
                onChange={(e) => setAuthCode(e.target.value)}
                dir="ltr"
              />
              <button className="transfer-btn" onClick={handleTransfer}>
                شروع انتقال
              </button>
            </div>
            <p className="transfer-form-note">* کد انتقال را از ثبت‌کننده فعلی خود دریافت کنید.</p>
          </div>
        </div>
      </section>

      <section className="transfer-features">
        <div className="wrap">
          <div className="sec-header">
            <span className="sec-tag">مزایای انتقال دامنه</span>
            <h2 className="sec-h">چرا دامنه خود را به <em>افرسل</em> انتقال دهید؟</h2>
            <p className="sec-p">با انتقال دامنه به افرسل، از مزایای ویژه و خدمات حرفه‌ای بهره‌مند شوید.</p>
          </div>
          <div className="transfer-features-grid">
            {features.map((feature, i) => (
              <div key={i} className="transfer-feature-card">
                <span className="transfer-feature-icon">{feature.icon}</span>
                <h3 className="transfer-feature-title">{feature.title}</h3>
                <p className="transfer-feature-desc">{feature.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="transfer-steps">
        <div className="wrap">
          <div className="sec-header">
            <span className="sec-tag">مراحل انتقال</span>
            <h2 className="sec-h">چگونه دامنه خود را <em>انتقال</em> دهید؟</h2>
            <p className="sec-p">فرآیند انتقال دامنه به افرسل در ۴ مرحله ساده انجام می‌شود.</p>
          </div>
          <div className="transfer-steps-grid">
            {steps.map((step, i) => (
              <div key={i} className="transfer-step-card">
                <div className="transfer-step-number">{step.number}</div>
                <h3 className="transfer-step-title">{step.title}</h3>
                <p className="transfer-step-desc">{step.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="transfer-faq">
        <div className="wrap">
          <div className="sec-header">
            <span className="sec-tag">سوالات متداول</span>
            <h2 className="sec-h">پاسخ به <em>سوالات</em> شما</h2>
            <p className="sec-p">پاسخ سوالات رایج درباره انتقال دامنه به افرسل.</p>
          </div>
          <div className="transfer-faq-grid">
            {faqs.map((faq, i) => (
              <div key={i} className="transfer-faq-item">
                <div className="transfer-faq-q">{faq.q}</div>
                <div className="transfer-faq-a">{faq.a}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="transfer-cta">
        <div className="wrap">
          <div className="cta-box">
            <h2 className="cta-title">
              دامنه خود را <em>رایگان</em> انتقال دهید
            </h2>
            <p className="cta-desc">
              با انتقال دامنه به افرسل، از تمدید یکساله رایگان و مدیریت DNS پیشرفته بهره‌مند شوید.
              فرآیند انتقال ساده، سریع و بدون هیچ هزینه اضافی است.
            </p>
            <div className="cta-btns">
              <button className="btn-lg primary" onClick={() => document.querySelector('.transfer-input')?.focus()}>
                شروع انتقال
              </button>
              <button className="btn-lg ghost" onClick={() => scrollTo('contact')}>
                مشاوره رایگان
              </button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default DomainTransfer;
